export enum AppError {
  HardStop = "hard_stop",
  Generic = "generic",
}

export enum ErrorType {
  ClsVulnerable = "CLS_VULNERABLE",
  ClsUnAuthSig = "CLS_UNAUTH_SIG",
  ClsNoToPayg = "CLS_NO_TO_PAYG",
  ClsCeasedTrading = "CLS_CEASED_TRADING",
  ClsFinDiffBBB = "CLS_FIN_DIFF_BBB",
  ClsComprehension = "CLS_COMPREHENSION",
  ClsFinDiffFCA = "CLS_FIN_DIFF_FCA",
}

export type Error = {
  code: string;
  description: string;
};

export type HardStop = {
  type: typeof AppError.HardStop;
  payload: { errorType: ErrorType[] };
};

export type GenericError = {
  type: typeof AppError.Generic;
  payload: { message: string };
};

export type ApplicationError = HardStop | GenericError;

export class GlobalAppError extends global.Error {
  constructor(message: string) {
    super();
    this.message = message;
  }
}

export const error = (code: string, description: string): Error => ({
  code,
  description,
});
